import camelcase from "camelcase";

export const camelToUnderScore = (key) => {
  return key.replace(/([A-Z])/g, "_$1").toLowerCase();
};

export const convertToSnakeCase = (obj) => {
  const newObj = {};
  for (const camel in obj) {
    newObj[camelToUnderScore(camel)] = obj[camel];
  }
  return newObj;
};

export const convertToCamelCase = (obj) => {
  const newObj = {};
  for (const underScore in obj) {
    newObj[camelcase(underScore)] = obj[underScore];
  }
  return newObj;
};

export const createErrors = (errors, message) => {
  const errorObj = {};
  errorObj["_error"] = message;
  errors.forEach((error) => {
    const attribute = camelcase(error.id);
    errorObj[camelcase(attribute)] = `${error.detail}`;
  });
  return errorObj;
};

export const humanize = (str) => {
  let i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
};
